// 设备对应的积木
export const deviceBlockList = {
    1: {
        motion: [
          "motion_forward",
          "motion_goback",
          "motion_turnleft",
          "motion_turnright",
          // "motion_moveleft",
          // "motion_moveright",
          "motion_dance",
          // "motion_gotoxyz",
          "motion_stop",
          "motion_speed",
          
          // 新增积木-2026.04.18
          "motion_advance", // 前进
          "motion_backward", // 后退
          "motion_turn_left", // 左转
          "motion_turn_right", // 右转
          "motion_stop_move", // 停止
          "motion_start_line_tracking", // 开始巡线
          "motion_stop_line_tracking", // 停止巡线
        ],
        display: ["all"],
        voice: ["all"],
        image: ["all"],
        event_custom: [
          // "all",

          "event_delay",
          "event_repeat",

          // 新增积木-2026.04.18
          "event_if_else", // 如果-那么-否则(判断积木)
          "event_repeat_condition", // 重复满足/不满足条件(判断循环积木)
          // "event_break_loop", // 跳出循环
          "event_gyro_reset", // 陀螺仪清零
          // "looks_show_text_duration",

          // 坦克小车新增15个积木-2026.04.18-start
          "event_and_or", // 且/或逻辑运算
          "event_left_line_sensor", // 左循迹传感器的值
          "event_right_line_sensor", // 右循迹传感器的值
          "event_gyro_value", // 陀螺仪的值
          "event_compare", // 比较运算符
          // 坦克小车新增15个积木-2026.04.18-end
          
        ],
        timing: [],
        system: ["all"],
    },
    2: {
        motion: [],
        display: [
            "looks_show_expression",
            "looks_screen_clear",
            "looks_show_text",
            "looks_show_image"
        ],
        voice: ["sounds_play"],
        image: [],
        event_custom: [
            "event_delay",
            "event_repeat", //重复执行
        ],
        timing: [],
        system: ["all"],
    },
    3: {
        motion: [
            "motion_forward",
            "motion_goback",
            "motion_turnleft",
            "motion_turnright",

            "control_servo_reset",
            "motion_nod",
            "motion_sway_x",
            "motion_sway_y", //左右摇摆
            "motion_fall",
            "motion_retract_leg",
            "motion_handshake",
            "motion_stretch",
            "motion_jump",
            "self_dog_move_control",
        ],
        display: [],
        voice: [
            // "sounds_play" //文字转语音
        ],
        image: [],
        event_custom: [
            "event_delay",
            "event_repeat", //重复执行
        ],
        timing: [],
        system: ["all"],
    },
    4: {
        motion: [
            "motion_forward",
            "motion_goback",
            "motion_turnleft",
            "motion_turnright",
        ],
        display: [],
        voice: [],
        image: [],
        event_custom: [],
        timing: [],
        system: [],
    },
    5: {
        motion: [],
        display: [
            "looks_show_expression",
            "looks_screen_clear",
            "looks_show_text",
            "looks_show_image",
        ],
        voice: ["sounds_play"],
        image: [],
        event_custom: [
            "event_delay",
            "event_repeat", //重复执行
            "event_button_pressed", // 当按下按键
            "event_if_button", // 如果按键那么否则
        ],
        timing: [],
        system: ["all"],
    },
};
